import { useState } from "react";
import { Button } from "@/components/ui/button";
import { AppLogger } from '@/lib/logger';

const log = AppLogger.getLogger(import.meta);
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { AddDistributorComposer } from "@/forms/sensory";
import { Plus } from "lucide-react";

interface AddDistributorButtonProps {
  onSuccess?: () => void;
}

export function AddDistributorButton({ onSuccess }: AddDistributorButtonProps) {
  const [open, setOpen] = useState(false);

  const handleSuccess = () => {
    setOpen(false);
    onSuccess?.();
  };

  const handleError = (error: Error) => {
    log.error("Failed to create distributor:", error);
    alert(`Failed to create distributor: ${error.message}`);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" className="gap-2">
          <Plus className="h-4 w-4" />
          Add Distributor
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Add New Distributor</DialogTitle>
        </DialogHeader>
        <AddDistributorComposer
          onSuccess={handleSuccess}
          onError={handleError}
          onCancel={() => setOpen(false)}
          showHeader={false}
        />
      </DialogContent>
    </Dialog>
  );
}
